import useDate from "~/ui-rtk/hooks/date"
const dayjs = useDate()

const getMonthLabel = (date: Date) => dayjs(date).format("MMM YYYY")

export { getMonthLabel }
